export default "__VITE_ASSET__Cd4p4hfi__"